import ThibodauxHeroSection from "./components/HeroSection";
import ThibodauxStickyNav from "./components/StickyNav";
import ThibodauxProcessingTimeSection from "./components/ProcessingTimeSection";
import ThibodauxServicesSection from "./components/ServicesSection";
import ThibodauxLocalAreaSection from "./components/LocalAreaSection";
import ThibodauxTestimonialsSection from "./components/TestimonialsSection";
import ThibodauxAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ThibodauxComparisonSection from "./components/ComparisonSection";
import ThibodauxMistakesSection from "./components/MistakesSection";
import ThibodauxHowItWorksSection from "./components/HowItWorksSection";
import ThibodauxFAQSection, { faqs } from "./components/FAQSection";
import ThibodauxHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ThibodauxFinalCTA from "./components/FinalCTA";
import ThibodauxTravelTimingSection from "./components/TravelTimingSection";
import ThibodauxDestinationsSection from "./components/DestinationsSection";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function ThibodauxPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Thibodaux"
        state="Louisiana"
        stateAbbr="LA"
        route="/thibodaux"
        title="Emergency Passport Thibodaux, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Thibodaux, LA — as fast as 24 hours. Serving offshore workers, Nicholls State travelers, and Lafourche Parish families. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Thibodaux, Louisiana"
        geoPosition="29.7958;-90.8229"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Thibodaux travelers with immediate departure needs — as fast as 24 hours for Lafourche Parish residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Thibodaux with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for Nicholls State students and Thibodaux families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Thibodaux, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Lafourche Parish families." },
          { name: "Name Change", description: "Passport correction and name change service for Thibodaux residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for offshore workers and Nicholls State travelers from Thibodaux." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <ThibodauxHeroSection />
      <ThibodauxStickyNav />
      <ThibodauxProcessingTimeSection />
      <ThibodauxLocalAreaSection />
      <ThibodauxServicesSection />
      <ThibodauxTravelTimingSection />
      <ThibodauxDestinationsSection />
      <ThibodauxTestimonialsSection />
      <ThibodauxAcceptanceFacilitiesSection />
      <ThibodauxComparisonSection />
      <ThibodauxMistakesSection />
      <ThibodauxHowItWorksSection />
      <ThibodauxFAQSection />
      <ThibodauxHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/thibodaux" state="LA" />
      <ThibodauxFinalCTA />
    </div>
  );
}